import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { IncidentUserModel } from "../models/incident-user.model";
import { UserModel } from "../components/src/lib/core/models/interfaces/user.model";

@Injectable({
    providedIn: "root",
})
export class IncidentUsersService {
    private httpClient: HttpClient = inject(HttpClient);
    private baseUrl = `${localStorage.getItem("incidentUrl")}/api/users`;

    public getAll(): Observable<IncidentUserModel[]> {
        return this.httpClient.get<IncidentUserModel[]>(this.baseUrl);
    }

    public getUsersForStaffing(incidentId?: string): Observable<Map<string, UserModel>> {
        const params = incidentId ? { incidentId } : {};
        return this.httpClient.get<Map<string, UserModel>>(`${this.baseUrl}/staffing`, { params });
    }

    public canCurrentUserEditReporter(): Observable<boolean> {
        return this.httpClient.get<boolean>(`${this.baseUrl}/edit-reporter`);
    }
}
